export default "__VITE_ASSET__YADhteky__"